import { css } from '@emotion/react'
import { Icons, Text, useTheme } from 'bold-ui'
import { IconLabel } from 'components/IconLabel'
import { Fragment } from 'react'

interface IconLabelPreNatalProps {
  icon: Icons
  iconText: string
  childrenText?: string
}

export function AcompanhamentoIconLabel(props: Readonly<IconLabelPreNatalProps>) {
  const { icon, iconText, childrenText } = props

  const theme = useTheme()
  const styles = createStyles()

  const color = theme.pallete.gray.c40
  const textColor = theme.pallete.gray.c10

  return (
    <Fragment>
      <IconLabel
        icon={icon}
        text={iconText}
        fontWeight='bold'
        textColor={textColor}
        color={color}
        size={1.5}
        hSpacing={0.5}
      />
      {childrenText && <Text style={styles.text}> {childrenText} </Text>}
    </Fragment>
  )
}

const createStyles = () => ({
  text: css`
    padding: 2rem;
  `,
})
